import { lazy, useEffect } from 'react'

import { Card } from '@procurify/ui'
import { useHistory, useLocation } from 'react-router'

import { toast } from '@webapp/components/Notification'
import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ExportDataPageLocationState } from './types'

const ExportDataLandingViewChunk = lazy(() =>
  import('../feature-sets/ExportDataLandingView').then(
    ({ ExportDataLandingView }) => ({
      default: ExportDataLandingView,
    })
  )
)

export const ExportDataPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()
  const history = useHistory()
  const location = useLocation<ExportDataPageLocationState | undefined>()

  // Access-denied warning for the RequestedExportsPage guard redirect
  // (BHV-036). Fired here — after the ToastContainer is mounted — so it
  // survives hard page loads; the state is cleared right away so the toast
  // fires exactly once per denial (not again on refresh/back).
  const accessDenied = location.state?.accessDenied === true

  useEffect(() => {
    if (accessDenied) {
      toast.warning({
        title: intl.formatMessage(messages.accessErrorTitle),
        children: intl.formatMessage(messages.accessErrorMessage),
      })

      history.replace({ ...location, state: undefined })
    }
  }, [accessDenied, history, intl, location])

  return (
    <Page
      pageTitle={intl.formatMessage(messages.exportDataTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.exportDataTitle),
        },
      ]}
    >
      <Card>
        <Card.Content>
          <ExportDataLandingViewChunk />
        </Card.Content>
      </Card>
    </Page>
  )
}
